var React = require('react');

function Credit (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n            #svg-credit .a {\n                fill: #fc4c02;\n                font-size: 13px;\n                font-family: Albra;\n                letter-spacing: 0.01em;\n            }\n        ")),React.createElement("text",{"className":"a","transform":"translate(10 217) rotate(-90)","key":1},React.createElement("tspan",{"x":"0","y":"0"},"Artwork & Design By Subtitled Design"))]);
}

Credit.defaultProps = {"id":"svg-credit","width":"13","height":"217","viewBox":"0 0 13 217"};

module.exports = Credit;

Credit.default = Credit;
